import script from "./BindToPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./BindToPhone.vue?vue&type=script&setup=true&lang=js"

import "./BindToPhone.vue?vue&type=style&index=0&id=d0854504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0854504"]])

export default __exports__